import { combineReducers } from 'redux';

import { DefinitionsEditorReducer, DefinitionsEditorState } from '~/modules/definitions/domain';
import { EditorReducer, EditorState } from './editor-reducers';
import { HomeReducer } from './home-reducers';
import { HomeState } from '~/actions/home-actions';

export interface ModeApp {
  editor: EditorState;
  home: HomeState;
  definitionEditor: DefinitionsEditorState;
}

export const app = combineReducers<ModeApp>({
  editor: EditorReducer,
  home: HomeReducer,
  definitionEditor: DefinitionsEditorReducer,
});
